import {getInvoices} from "../../utils/api";

export const GET_INVOICES_FETCHING = 'GET_INVOICES_FETCHING';
export const GET_INVOICES_FAIL = 'GET_INVOICES_FAIL';
export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS';

export const getInvoicesFetchingAction = (query, order) => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch({type: GET_INVOICES_FETCHING});
    getInvoices(query, state.auth.user.accessToken, order)
      .then(({data}) => {
        dispatch(getInvoicesSuccess(data.data));
      })
      .catch(e => {
        dispatch(getInvoicesFail(e));
      })
  }
};

export const getInvoicesFail = (e) => {
  return {type: GET_INVOICES_FAIL, payload: {message: e?.message}}
};

export const getInvoicesSuccess = (invoices) => {
  return {type: GET_INVOICES_SUCCESS, payload: {invoices}}
};